import React, { useContext, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import formatNumber from '../../../../fns/formatNumber';
import Divider from '@material-ui/core/Divider';
import Accordion from '../../../../components/Accordion/Accordion';
import FleetsTextFields from '../../../../components/TextFields/FleetsTextFields';
import SelectState from '../../../../components/FormInputs/SelectStates';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { store } from './Orders';
import { store as mainStore } from '../../../../store';
import { useLocation } from 'react-router-dom';
import useRules from '../../../../hooks/useRules';
import { useQuery } from 'react-query';

const useStyles = makeStyles((theme) => ({
  searchSecondRow: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'stretch',
    alignItems: 'flex-start',
    '& > div:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
    '& > div': {
      flex: 1,
    },
  },
  secondaryFilters: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));
function useQueryFn() {
  return new URLSearchParams(useLocation().search);
}

const OrdersFilters = () => {
  const classes = useStyles();
  const [rules, hasRule, isAdmin] = useRules();
  var orderStatuses = {
    pending: 'درحال بررسی',
    tendering: 'مناقصه',
    getWaybill: 'صدور بارنامه',
  };
  hasRule('orders_filters_sendToFreight') &&
    (orderStatuses.sendToFreight = 'باربری');
  hasRule('orders_filters_sendToAdmin') &&
    (orderStatuses.sendToAdmin = 'مدیرسیستم');
  hasRule('orders_filters_returned') && (orderStatuses.returned = 'برگشت بار');
  hasRule('orders_filters_rejected') && (orderStatuses.rejected = 'رد بار');
  hasRule('orders_filters_movingTowardsOrigin') &&
    (orderStatuses.movingTowardsOrigin = 'بارگیری');
  hasRule('orders_filters_transporting') &&
    (orderStatuses.transporting = 'درحال حمل');
  hasRule('orders_filters_delivered') &&
    (orderStatuses.delivered = 'تحویل شده');
  hasRule('orders_filters_canceled') && (orderStatuses.canceled = 'کنسل بار');

  const query = useQueryFn();
  const s = query.get('status');
  const firstRun = useRef(true);
  const {
    state: {
      page,
      filters: { status, fleetOptions, destinationState },
    },
    dispatch,
    actions: { fetchingOrders },
  } = useContext(store);
  const {
    showError,
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  let _orderStatuses = [];
  const handleChangeOrderStatus = (e) => {
    const { name, checked } = e.target;
    dispatch({ type: 'ORDER_STATUS', payload: { name, checked } });
  };
  for (let [key, value] of Object.entries(orderStatuses)) {
    _orderStatuses.push(
      <FormControlLabel
        key={key}
        control={<Checkbox color="primary" />}
        label={value}
        labelPlacement="end"
        checked={status[key]}
        onChange={handleChangeOrderStatus}
        name={key}
      />
    );
  }
  const handleChangeFleetOptions = (selection) => {
    dispatch({ type: 'FLEET_OPTIONS', payload: selection });
  };
  const handleChangeDestination = (destination) => {
    dispatch({ type: 'DESTINATION', payload: destination });
  };
  const loadOrders = async () => {
    let filter = {};
    destinationState &&
      (filter = {
        ...filter,
        destinationState: destinationState.value,
      });
    fleetOptions?.length &&
      (filter = { ...filter, fleetOptions: fleetOptions.map((f) => f._id) });
    if (firstRun.current && s) {
      filter = { ...filter, status: s };
    } else {
      const _status = Object.entries(status)
        .filter((s) => s[1])
        .map((s) => s[0]);
      filter = { ...filter, status: _status };
    }
    try {
      dispatch({ type: 'LOADING' });
      const orders = await fetchingOrders(page || 1, itemsCountPerPage, filter);
      dispatch({ type: 'ORDERS', payload: orders });
    } catch (error) {
      showError(error);
    }
  };

  const { data, isLoading } = useQuery(
    ['loadOrders', status, fleetOptions, destinationState, page],
    () => loadOrders(),
    { refetchOnWindowFocus: false, retry: false, cacheTime: 5 * 60 * 1000 }
  );

  useEffect(() => {
    if (firstRun.current && s) {
      dispatch({
        type: 'ORDER_STATUS',
        payload: { name: 'tendering', checked: false },
      });
      dispatch({
        type: 'ORDER_STATUS',
        payload: { name: 'pending', checked: false },
      });
      dispatch({ type: 'QUERY_ORDER_STATUS', payload: s });
      firstRun.current = false;
    }
  }, [s, firstRun.current]);

  return (
    <div>
      <Accordion title="فیلتر سفارشات">
        {_orderStatuses}
        <Divider style={{ margin: '15px 0' }} />
        <div className={classes.searchSecondRow}>
          <div className={classes.secondaryFilters}>
            <FleetsTextFields
              selection={fleetOptions}
              onChange={handleChangeFleetOptions}
            />
            <SelectState
              menuPortalTarget={document.body}
              placeholder="انتخاب مقصد"
              onSelect={handleChangeDestination}
              state={destinationState}
            />
          </div>
        </div>
      </Accordion>
      <Divider style={{ margin: '15px 0' }} />
    </div>
  );
};

export default React.memo(OrdersFilters);
